import {Component, OnInit, Injector, AfterViewInit, Input, OnDestroy} from '@angular/core';
import {AppComponentBase} from '../../../../services/AppComponentBase';
import {ScannerSide, ScannerChartingStudy} from '../../interfaces/scanner.enums';
import {IRSIScanRule, IEMAScanRule, chartingSaved} from '../../interfaces/scanner.interfaces';



@Component({
    selector: 'app-scanner-EMA',
    template: require('./scanner-EMA.component.html'),
    styles: [require('./scanner-EMA.component.scss')]
})
export class ScannerEMASelectorComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {
    ngAfterViewInit(): void {
        let v = this.workspace.initLoadScan;
        if(v != null) {
            this.loadScanData(v);
            //  this.workspace.initLoadScan = null;
        }
    }

    public loadScanData(v: any) {
        let loadScanData: chartingSaved = (!this.narrowScannerMode) ? <chartingSaved> v.savedData : <chartingSaved> v.savedDataSecondary;
        //console.log(v);
        this.workspace.scannerSearch_period = loadScanData.period;

        let scanRule: IEMAScanRule = <IEMAScanRule> loadScanData.rule;
        this.emaPeriod = scanRule.period;
        this.workspace.scannerSearch_side = scanRule.direction;
        this.enableAdvancedSetup = true;
        if(scanRule.direction == ScannerSide.SCANNER_SIDE_BUY) {
            this.overbought = true;

        }
        if(scanRule.direction == ScannerSide.SCANNER_SIDE_SELL) {
            this.oversold = true;

        }
        this.workspace.canSelectedSavedScanUpdate = false;
        this.workspace.allowScanProcess = true;
    }

    constructor(injector: Injector) {
        super(injector);

        if(!this.workspace.isNarrowScanMode) {
            this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_BUY;
            this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.emaPeriod};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }


        this.workspace.globaGridMode.changeScannerSide.subscribe(v => {
            if(!this.narrowScannerMode) {
                if(this.workspace.scannerSearch_chartingstudy == ScannerChartingStudy.SCANNER_EMA) {
                    if(v == ScannerSide.SCANNER_SIDE_BUY) {
                        this.overbought = true;
                        this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
                    }
                    if(v == ScannerSide.SCANNER_SIDE_SELL) {
                        this.oversold = true;
                        this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
                    }
                }
            }
        })

        this.workspace.globaGridMode.changeScannerNarrowSide.subscribe(v => {
            if(this.narrowScannerMode) {
                if(this.workspace.scannerSearch_Narrow_chartingstudy == ScannerChartingStudy.SCANNER_EMA) {
                    if(v == ScannerSide.SCANNER_SIDE_BUY) {
                        this.overbought = true;
                        this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
                    }
                    if(v == ScannerSide.SCANNER_SIDE_SELL) {
                        this.oversold = true;
                        this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
                    }
                }
            }
        })


        this.workspace.globaGridMode.loadScannerRule.subscribe(v => {

            if(v.study == ScannerChartingStudy.SCANNER_EMA)
                this.loadScanData(v)

        });



    }
    public subscribers: any = {};
    ngOnDestroy() {
        // this.subscribers.load.unsubscribe();
    }
    public _narrowScannerMode: boolean = false;

    @Input() public set narrowScannerMode(value: boolean) {
        this._narrowScannerMode = value
        if(value == true) {
            this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_BUY;
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.emaPeriod};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }

    public get narrowScannerMode() {
        return this._narrowScannerMode;
    }


    //value: number = 5;

    private _emaPeriod: number = 20;
    public get emaPeriod(): number {
        return this._emaPeriod;
    }
    public set emaPeriod(value: number) {
        this._emaPeriod = value;
        if(!this.narrowScannerMode) {
            this.scanRule = {direction: this.workspace.scannerSearch_side, period: value};
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: value};
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }


    public get isPeriodValid() {
        return !isNaN(Number(this.emaPeriod))
    }


    private _enableAdvancedSetup: boolean = false;
    public get enableAdvancedSetup(): boolean {
        return this._enableAdvancedSetup;
    }
    public set enableAdvancedSetup(value: boolean) {
        this._enableAdvancedSetup = value;
    }

    public get isBandSelectedValid() {
        return this.overbought || this.oversold;
    }


    private _overbought: boolean = true;
    public get overbought(): boolean {
        return this._overbought;
    }
    public set overbought(value: boolean) {
        this._oversold = !value;
        this._overbought = value;
        if(value == true) {

            if(!this.narrowScannerMode) {
                this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_BUY;
                this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.emaPeriod};
            }
            else {
                if(this.workspace.usePrimarySide) {
                    return
                }
                this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_BUY;
                this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.emaPeriod};
            }

            this.oversold = false;
        }

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }


    }


    private _oversold: boolean = false;
    public get oversold(): boolean {
        return this._oversold;
    }
    public set oversold(value: boolean) {
        this._oversold = value;
        this._overbought = !value;
        if(value == true) {

            if(!this.narrowScannerMode) {
                this.workspace.scannerSearch_side = ScannerSide.SCANNER_SIDE_SELL;
                this.scanRule = {direction: this.workspace.scannerSearch_side, period: this.emaPeriod};
            }
            else {
                if(this.workspace.usePrimarySide) {
                    return
                }
                this.workspace.scannerSearch_Narrow_side = ScannerSide.SCANNER_SIDE_SELL;
                this.scanRule = {direction: this.workspace.scannerSearch_Narrow_side, period: this.emaPeriod};
            }

            this.overbought = false;
        }

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));
        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }


    }


    public overboughtAction() {
        this.overbought = !this.overbought
    }

    public oversoldAction() {
        this.oversold = !this.oversold
    }






    ngOnInit() {
    }


    public scanRule: IEMAScanRule = {direction: this.workspace.scannerSearch_side, period: this.emaPeriod}


}

